import { render, staticRenderFns } from "./ForumResponseBody.vue?vue&type=template&id=317e334b&scoped=true"
import script from "./ForumResponseBody.vue?vue&type=script&lang=js"
export * from "./ForumResponseBody.vue?vue&type=script&lang=js"
import style0 from "./ForumResponseBody.vue?vue&type=style&index=0&id=317e334b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317e334b",
  null
  
)

export default component.exports